import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const trackingCode = urlParams.get("v");

    if (trackingCode) {
      const sourceMap = {
        re: "Resume",
        li: "LinkedIn",
        gh: "GitHub",
        cl: "Cover Letter",
        em: "Email Signature",
        ap: "Application Portal",
        xi: "XING",
      };

      const resolvedSource = sourceMap[trackingCode] || trackingCode;

      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "portfolio_visit", {
          traffic_source: resolvedSource,
        });
      }
    }

    const cleanUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    window.history.replaceState({ path: cleanUrl }, "", cleanUrl);
  }, []);

  return (
    <div className="flex grow flex-col items-center justify-center text-center">
      <h1 className="text-4xl md:text-6xl font-bold mb-4">404</h1>
      <p className="text-lg md:text-xl mb-6">
        Oops! The page you're looking for doesn't exist.
      </p>
      <Link to="/" className="text-blue-500 hover:underline text-lg md:text-xl">
        Go back to the homepage
      </Link>
    </div>
  );
}
